// @ts-nocheck
import React, { useState, memo } from "react";
import {
  Paper,
  TextField,
  Button,
  Grid,
  Box,
  FormControl,
  Dialog,
  Typography,
} from "@material-ui/core/";
import {
  userValid,
  passwordValid,
  CompanyNameValid,
} from "../../utils/validations";
import api from "../../api";
import PasswordField from "../../partials/PasswordField";

const isValid = (name, lastName, password, company) => {
  if (
    userValid(name) &&
    userValid(lastName) &&
    passwordValid(password) &&
    CompanyNameValid(company)
  ) {
    return true;
  }
  return false;
};

const Registration = ({
  jwtData,
  setRenderState,
  USER_REGISTER,
  params,
  USER_NOT_FOUND,
}) => {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [companyName, setCompanyName] = useState("");

  const registration = () => {
    api
      .post("/public/v1/register", {
        first_name: name,
        last_name: lastName,
        email: jwtData.email,
        password: password,
        email_token: params.token,
        company: companyName,
      })
      .then(setRenderState(USER_REGISTER))
      .catch((e) => {
        console.log(e);
        setRenderState(USER_NOT_FOUND);
      });
  };

  return (
    <Dialog maxWidth="xs" open>
      <Paper variant="outlined" style={{ maxWidth: 350 }}>
        <Box
          p={2}
          pb={0}
          width={1}
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="subtitle1">Registration</Typography>
        </Box>
        <Box
          p={2}
          width={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Grid container spacing={2} direction="column">
            <Grid item xs>
              <FormControl size="small" variant="outlined" fullWidth>
                <TextField
                  size="small"
                  name="login"
                  label="E-Mail"
                  variant="outlined"
                  value={jwtData.email}
                  disabled
                />
              </FormControl>
            </Grid>

            <Grid item xs>
              <TextField
                name="first_name"
                size="small"
                fullWidth
                label="First Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={!userValid(name) && name !== ""}
                helperText={
                  !userValid(name) &&
                  name !== "" &&
                  "The First Name field cannot contain less than two letters, as well as special characters and numbers."
                }
              />
            </Grid>
            <Grid item xs>
              <TextField
                name="last_name"
                size="small"
                fullWidth
                label="Last Name"
                variant="outlined"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                error={!userValid(lastName) && lastName !== ""}
                helperText={
                  !userValid(lastName) &&
                  lastName !== "" &&
                  "The Last Name field cannot contain less than two letters, as well as special characters and numbers."
                }
              />
            </Grid>
            <Grid item xs>
              <TextField
                name="Company name"
                size="small"
                fullWidth
                label="Company name"
                variant="outlined"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                helperText={
                  !CompanyNameValid(companyName) &&
                  companyName !== "" &&
                  "The Company name must be 2-99 letters, and can contain space, hyphen, and the underline sign, cannot start or end with a whitespace or have more than 1 whitespace in a row"
                }
                error={!CompanyNameValid(companyName) && companyName !== ""}
              />
            </Grid>
            <Grid item xs>
              <PasswordField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                helperText={
                  !passwordValid(password) &&
                  password !== "" &&
                  "Password should be between 8-99 symbols, contain numbers, uppercase, lowercase and special characters"
                }
                error={!passwordValid(password) && password !== ""}
              />
            </Grid>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              pr={1}
              pt={1}
            >
              <FormControl size="small" variant="outlined">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!isValid(name, lastName, password, companyName)}
                  onClick={registration}
                >
                  Submit
                </Button>
              </FormControl>
            </Box>
          </Grid>
        </Box>
      </Paper>
    </Dialog>
  );
};

export default memo(Registration);
